module.exports = __webpack_public_path__ + "media/images/icon__calendar@3x-8b0ac83ed32202f75905de3649dda8f8.png";